import React from 'react';

const ChevronRightIcon: React.FC<
  React.PropsWithChildren<React.SVGProps<SVGSVGElement>>
> = (props) => {
  return (
    <svg
      role="presentation"
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      version="1.1"
      viewBox="0 0 300 300"
      xmlSpace="preserve"
      transform="scale(1.5)"
      {...props}
    >
      <g transform="translate(-1764.834 -2959.667)">
        <path
          d="M1883.1 3201.9l87.3-75.3-87.3-109.2-23.8 13.4 60.2 95.9-60.2 61.4 23.8 13.8z"
          fill="#e9b400"
        ></path>
      </g>
    </svg>
  );
};

export default ChevronRightIcon;
